import { ModelName, SelectSourceOptionType } from 'webapp/enums/enums';

import AlertRecord from 'webapp/models/alert-setting';
import BoardRecord from 'webapp/models/board';
import BoardLoopRecord from 'webapp/models/board-loop';
import BoardShareRecord from 'webapp/models/board-share';
import CustomQueryRecord from 'webapp/models/custom-query';
import GoalRecord from 'webapp/models/goal';
import ReportRecord from 'webapp/models/report';
import ScorecardRecord from 'webapp/models/scorecard';
import ScriptRecord from 'webapp/models/script';
import SourceRecord from 'webapp/models/source';

function getPrettyModelName(model: unknown): string {
	if (model instanceof BoardRecord || fakeInstanceOf(model, ModelName.BOARD)) {
		return 'dashboard';
	} else if (model instanceof GoalRecord || fakeInstanceOf(model, ModelName.GOAL)) {
		return 'goal';
	} else if (model instanceof ReportRecord || fakeInstanceOf(model, ModelName.REPORT)) {
		return 'report';
	} else if (model instanceof BoardLoopRecord || fakeInstanceOf(model, ModelName.BOARD_LOOP)) {
		return 'looped dashboard';
	} else if (model instanceof SourceRecord || fakeInstanceOf(model, ModelName.SOURCE)) {
		return getPrettySourceName(model);
	} else if (model instanceof BoardShareRecord || fakeInstanceOf(model, ModelName.BOARD_SHARE)) {
		return 'snapshot';
	} else if (model instanceof AlertRecord || fakeInstanceOf(model, ModelName.ALERT_SETTING)) {
		return 'alert';
	} else if (model instanceof ScorecardRecord || fakeInstanceOf(model, ModelName.SCORECARD)) {
		return 'scorecard';
	} else if (
		model instanceof CustomQueryRecord ||
		fakeInstanceOf(model, ModelName.CUSTOM_QUERY)
	) {
		return 'built metric';
	} else if (model instanceof ScriptRecord || fakeInstanceOf(model, ModelName.SCRIPT)) {
		return 'calculated metric';
	} else if (fakeInstanceOf(model, ModelName.TEAM)) {
		return 'space';
	}

	return '';
}

/** Datasets and merged datasets are sources too, and are named after what the user made them as. */
function getPrettySourceName(model: unknown): string {
	const { selectedSourceOption } = model as { selectedSourceOption?: SelectSourceOptionType };

	switch (selectedSourceOption) {
		case SelectSourceOptionType.MERGED:
			return 'merged dataset';
		case SelectSourceOptionType.DATASETS:
		case SelectSourceOptionType.DATASET_CUSTOM_INTEGRATION:
			return 'dataset';
		default:
			return 'data source';
	}
}

function fakeInstanceOf(model: unknown, name: ModelName): boolean {
	// using this instead of instanceof because of circular dependencies
	// careful when replacing buffered-model modelName !!
	return (model as { modelName?: unknown }).modelName === name;
}

export { getPrettyModelName, fakeInstanceOf };
